import {
  athleticsData,
  baseballData,
  baseBallSettingOptions,
  cameraSettingsOptions,
  cameraSettingsOptionsBaseball,
  exerciseSettingOptions,
  golfData,
  swingSettingOptions,
} from "./constants";

export function handleToggleOptions(toggleOptions, item) {
  let toggledOptionsAfterClicked = toggleOptions;

  const activeOptions = toggledOptionsAfterClicked.options
    .filter((state) => state[state?.value])
    .map((state) => state?.value);
  const conditionForCombined =
    // (activeOptions.includes("club") && activeOptions.includes("ball")) ||
    activeOptions.includes("combined") &&
    item.value !== "club" &&
    item.value !== "ball";

  return {
    ...toggledOptionsAfterClicked,
    options: toggledOptionsAfterClicked.options.map((item) => {
      let key = item.value;
      if (conditionForCombined) {
        if (key === "club" || key === "ball") {
          return { ...item, [key]: false };
        }
        if (key === "combined") {
          return { ...item, [key]: true };
        }
      } else {
        if (key === "combined") {
          return { ...item, [key]: false };
        }
      }
      return item;
    }),
  };
}

export function sportBasedCameraSettingsList(sportName) {
  if (sportName === "golf") {
    return cameraSettingsOptions;
  }

  if (sportName === "baseball") {
    return cameraSettingsOptionsBaseball;
  }

  return cameraSettingsOptions;
}

export function sportsBasedOptionsList(sportName) {
  switch (sportName) {
    case "golf":
      return swingSettingOptions;
    case "baseball":
      return baseBallSettingOptions;
    case "athletics":
      return exerciseSettingOptions;
    default:
      return swingSettingOptions;
  }
}

export function getNameOfHeading(sportName) {
  switch (sportName) {
    case "golf":
      return "Swing Settings";
    case "baseball":
      return "Baseball Settings";
    case "athletics":
      return "Exercise Settings";

    default:
      return "Swing Settings";
  }
}

export function sportStateSetter(sportName, setState) {
  return (key, value) => {
    setState((prevState) => ({
      ...prevState,
      [sportName]: {
        ...prevState[sportName],
        [key]: value,
      },
    }));
  };
}

export function getSelectedModelTypes(ModelTypeSettingsOptions) {
  const totalOptions = ModelTypeSettingsOptions.options;
  const selectedModelItems = totalOptions.filter((item) => !!item[item.value]);
  const final = selectedModelItems.map((item) => {
    const { value, version } = item;
    return { model: value, version };
  });
  return final;
}

export function getInitialData({ email, capturedFrameRateDefault }) {
  const initialStateOfGolfData = {
    ...golfData,
    capturedFrameRate: capturedFrameRateDefault,
  };
  const initialStateOfAthleticsData = {
    ...athleticsData,
    capturedFrameRate: capturedFrameRateDefault,
  };
  const initialStateOfBaseball = {
    ...baseballData,
    email,
  };

  const initialAllData = {
    baseball: initialStateOfBaseball,
    golf: initialStateOfGolfData,
    athletics: initialStateOfAthleticsData,
  };

  return { initialAllData };
}
